// Buy bar in the scroll story (sections/kb-scroll-story.liquid, 2 Nov meeting): keeps the Hero Bag shoppable while the
// story runs. Pick a colour, optionally a second one for the pair price, then add both to the bag in one go.
(() => {
  const money = (pence) => `£${(pence / 100).toFixed(pence % 100 ? 2 : 0)}`;
  const init = (bar) => {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const story = bar.closest('[data-kb-story]');
    const second = bar.querySelector('[data-kb-second]');
    const price = bar.querySelector('[data-kb-buy-price]');
    const btn = bar.querySelector('[data-kb-buy-add]');
    const single = parseInt(bar.dataset.price, 10) || 0;
    let a = null, b = null, busy = false;

    const paint = () => {
      [['1', a], ['2', b]].forEach(([slot, pick]) => bar.querySelectorAll(`[data-slot="${slot}"] .kb-story__dot`).forEach((d) => {
        const on = d.dataset.variant === pick;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-pressed', on ? 'true' : 'false');
      }));
      if (second) second.hidden = !a;
      if (story) story.classList.toggle('has-second', !!a);
      price.innerHTML = '';
      const main = document.createElement('b');
      const sub = document.createElement('small');
      main.textContent = b ? bar.dataset.pair : money(single);
      sub.textContent = b ? bar.dataset.pairNote : bar.dataset.free;
      price.append(main, sub);
      if (busy) return;
      btn.disabled = !a;
      btn.textContent = b ? 'Add both to bag' : 'Add to bag';
    };

    bar.addEventListener('click', async (e) => {
      const dot = e.target.closest('.kb-story__dot');
      if (dot) {
        if (dot.closest('[data-slot="1"]')) a = dot.dataset.variant;
        else b = b === dot.dataset.variant ? null : dot.dataset.variant;
        paint();
        return;
      }
      if (!e.target.closest('[data-kb-buy-add]') || !a || busy) return;
      busy = true;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      const items = a === b ? [{ id: +a, quantity: 2 }] : [{ id: +a, quantity: 1 }, ...(b ? [{ id: +b, quantity: 1 }] : [])];
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('add failed');
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.refresh === 'function') { await drawer.refresh(); drawer.open(); } else { window.location.href = '/cart'; }
        btn.textContent = 'Added ✓';
        setTimeout(() => { busy = false; paint(); }, 1800);
      } catch (_) {
        busy = false;
        btn.disabled = false;
        btn.textContent = 'Try again';
      }
    });
    paint();
  };
  document.querySelectorAll('[data-kb-buy]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-kb-buy]').forEach(init));
})();
